import React, { useState, useEffect } from 'react';
import store from './store';
import { Modal, Form, Upload, Button, message } from 'antd';
import { observer } from 'mobx-react';
import { UploadOutlined } from '@ant-design/icons';
import { http, deepCopy } from 'libs';


export default observer(function IFormUpload() {

    const [loading, setLoading] = useState(false);
    const [attach, setAttach] = useState()
    const [domain, setDomain] = useState('');



    function handleSubmit() {
        if (!attach) return message.error('请选择上传的文件');
        message.success('操作成功');
        store.formUploadVisible = false;
        if (store.isHeadUpload) {
            store.headAttachment = attach
            store.headDomain = domain
        }else{
            let records=deepCopy(store.record)
            records.find(v=>v.id===store.rowId).attachment = attach
            records.find(v=>v.id===store.rowId).attachment_domain = domain
            store.record = records
        }
        // setLoading(true);
        // http.post(
        //     '/api/purchase/item/attachment/',
        //     { item_id: store.rowId, attachment: attach })
        //     .then(() => {
        //         message.success('操作成功');
        //         store.formUploadVisible = false;
        //         store.records = [];
        //         store.fetchRecords()
        //     }).finally(() => setLoading(false))
    }

    function fileChange(v) {
        if (v.file.status === 'uploading') {
            setLoading(true)
        }
        if (v.file.status === 'done') {
            setLoading(false)
            setAttach(v.file.response.data.path)
            setDomain(v.file.response.data.domain)
        }
    }

    return (
        <Modal
            title={'附件上传'}
            visible
            maskClosable={false}
            onOk={handleSubmit}
            confirmLoading={loading}
            onCancel={store.set_v('formUploadVisible', false)}
        >
            <Form>
                <Form.Item
                    label="文件上传"
                    labelCol={{ span: 5 }}
                >
                    <Upload
                        maxCount={1}
                        data={{ path: "clinical" }}
                        headers={{ 'X-Token': localStorage.getItem('token') }}
                        action="/api/oss/upload/"
                        onChange={v => fileChange(v)}
                        onRemove={v => setAttach()}
                    >
                        <Button icon={<UploadOutlined />}>
                            点击上传
                        </Button>
                    </Upload>
                </Form.Item>
            </Form>
        </Modal>
    )
})